// @ts-nocheck
import { QUIZ_MODE_TYPE } from '@utils/video-helpers/types'
import { QuizAnswer } from '@components/Interactivity/Quiz/QuizAnswer'
import '../quiz-styles.less'
import { usePlayerContext } from '@hooks/index'

export const QuizAnswers = (props) => {
  const { quizData, chosenAnswers, setChosenAnswers, quizQuestionText, highlightedAnswer, setHighlightedAnswer } = props
  const {
    viewObjects: { answersContainer, controlDefault, controlChecked, controlHighlighted },
    answerList,
    answersMap,
    quizMode,
    answerState,
    topPosition,
  } = quizData

  const { playerBounding } = usePlayerContext()

  const isCheckbox = quizMode === QUIZ_MODE_TYPE.MULTI_SELECT

  const createOnAnswerChooseHandler = (answerId) => (event) => {
    const {
      target: { checked },
    } = event
    setChosenAnswers((checkedAnswers) => ({ ...(isCheckbox ? checkedAnswers : {}), [answerId]: checked ?? false }))
    setHighlightedAnswer(null)
    quizData.setAnswerState([])
  }

  return (
    <fieldset className="quiz-fieldset" style={quizData.getElementStyles(playerBounding, answersContainer)}>
      <legend className="sr-only">{quizQuestionText}</legend>
      {answerList.map((answerId, index) => {
        const answerData = answersMap[answerId]
        if (!answerData) return null
        const { background, control, text: textData, image: imageData, extraControl } = answerData
        const inputType = isCheckbox ? 'checkbox' : 'radio'
        const isChecked = answerState.includes(answerId) || !!chosenAnswers[answerId]
        const isHighlighted = highlightedAnswer === answerId

        let extraControlViewData = null
        const controlViewData = {
          ...control,
          isChecked,
          isHighlighted,
          src: isChecked
            ? controlChecked?.src
            : isHighlighted && controlHighlighted?.src
              ? controlHighlighted.src
              : controlDefault?.src,
        }
        if (extraControl) {
          // consider if extraControl present, main control has no background -> image based quiz with bgFrame control
          delete controlViewData.src
          extraControlViewData = {
            ...extraControl,
            src: isChecked
              ? controlChecked?.src
              : isHighlighted && controlHighlighted?.src
                ? controlHighlighted.src
                : controlDefault?.src,
            isChecked,
          }
        }

        return (
          <QuizAnswer
            key={answerId}
            answerId={answerId}
            index={index}
            backgroundObject={background}
            container={{ top: topPosition, left: answersContainer.left }}
            controlViewData={controlViewData}
            extraControlViewData={extraControlViewData}
            isHighlighted={isHighlighted}
            textData={textData}
            imageData={imageData}
            inputType={inputType}
            isChecked={isChecked}
            isCheckbox={isCheckbox}
            getElementStyles={quizData.getElementStyles}
            onAnswerChooseHandler={createOnAnswerChooseHandler(answerId)}
          />
        )
      })}
    </fieldset>
  )
}
